export const AvatarNavbarFoodDrinksIcon = ({
  className = '',
}: {
  className?: string
}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.36 14.8C14.47 15.6 12.39 16.04 10.21 16.04C8.02 16.04 5.94 15.6 4.05 14.8"
        stroke="#737373"
        strokeWidth="1.15"
        strokeMiterlimit="10"
      />
      <path
        d="M2.57 17.71C4.9 18.78 7.48 19.38 10.21 19.38C12.93 19.38 15.52 18.78 17.84 17.71L10.21 2.71L2.57 17.71Z"
        stroke="#737373"
        strokeWidth="1.15"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M8.96 13.54C9.65 13.54 10.21 12.98 10.21 12.29C10.21 11.6 9.65 11.04 8.96 11.04C8.27 11.04 7.71 11.6 7.71 12.29C7.71 12.98 8.27 13.54 8.96 13.54Z"
        fill="#737373"
      />
      <path
        d="M10.21 9.38C10.67 9.38 11.04 9 11.04 8.54C11.04 8.08 10.67 7.71 10.21 7.71C9.75 7.71 9.38 8.08 9.38 8.54C9.38 9 9.75 9.38 10.21 9.38Z"
        fill="#737373"
      />
      <path
        d="M12.71 13.54C13.17 13.54 13.54 13.17 13.54 12.71C13.54 12.25 13.17 11.88 12.71 11.88C12.25 11.88 11.88 12.25 11.88 12.71C11.88 13.17 12.25 13.54 12.71 13.54Z"
        fill="#737373"
      />
    </svg>
  )
}
